import { SelectOption } from '@globaleris/ui.library'
import { Broker } from '../../../api'
import { EnumPriceCalculationType } from '../../../api/Argentia/enums'
import { Currency } from '../../../api/Pioneer/model/Currency'
import { UnitPrice } from '../../../api/Pioneer/model/UnitPrice'

export interface SelectOptions {
  unitPrices: UnitPrice[]
  counterparts: SelectOption[]
  balanceZones: SelectOption[]
  deliveryPoints: SelectOption[]
  tradeTypes: SelectOption[]
  books: SelectOption[]
  contractedProducts: SelectOption[]
  brokers: SelectOption[]
  currencies: Currency[]
  currenciesOptions: SelectOption[]
  measureUnitsOptions: SelectOption[]
  contractOptions: SelectOption[]
}

export type FetchingDependencies = Record<keyof SelectOptions, boolean> & { invoiceCycles: boolean }

export interface formDependencies {
  id?: number
  code?: string
  description?: string
  precioUnitario?: number
  marketType?: number
  commodity: number
  priceType: number
  redondeo?: number
  relatedFuturePrice?: number | null
  priceExpression?: string
  priceCalculationType?: EnumPriceCalculationType | null
}

export interface ModifiedBrokersModel {
  broker: Broker
  action?: string
}

export interface TradeFormValidations {
  isDirty: boolean
  initDate: boolean
  endDate: boolean
  signDate: boolean
  counterpart: boolean
  quantity: boolean
  deliveryPoint: boolean
  positionType: boolean
  measureUnit: boolean
}

export namespace RulebookValidations {
  export const INIT_DATE = 'initDate'
  export const END_DATE = 'endDate'
  export const SIGN_DATE = 'signDate'
  export const COUNTERPART = 'counterpart'
  export const QUANTITY = 'quantity'
  export const POSITION_TYPE = 'positionType'
  export const DELIVERY_POINT = 'deliveryPoint'
  export const MEASURE_UNIT = 'measureUnit'
}
export type RulebookValidations = (typeof RulebookValidations)[keyof typeof RulebookValidations]
